<script setup lang="ts">
definePageMeta({
  middleware: 'auth',
  auth: {
    unauthenticatedOnly: true,
    navigateAuthenticatedTo: '/u/moje-konto',
  },
})
useHead({
  titleTemplate: 'Rejestracja - %s',
  meta: [
    { name: 'robots', content: 'index,follow' }
  ]
})
</script>

<template>
  <div class="container mx-auto">
    <Breadcrumbs :breadcrumbs="[{ name: 'Zarejestruj się' }]" />
    <div class="flex flex-col items-center my-[30px]">
      <div class="w-full md:w-1/3">
        <h2 class="text-20 md:text-32 font-bold mb-[15px]">
          Zarejestruj się
        </h2>
        <UserRegisterForm />
      </div>
    </div>
    <div class="flex justify-center">
      <div class="w-full">
        <UserLoginButton />
      </div>
    </div>
  </div>
</template>
